import { useCallback } from 'react';
import { useRewardStoreActions } from '@/store';
import { useGetBonuses } from '../../get-bonus&get-offers';
import useGetClaimedRewards from '../get-claimed-rewards';

const useGetRewards = () => {
	const { setOfferRewards, setClaimedRewards } = useRewardStoreActions();
	const { getClaimedRewards } = useGetClaimedRewards();
	const { getBonuses } = useGetBonuses();

	const getUnclaimedBonuses = useCallback(async () => {
		const [rewardsResult, claimedResult] = await Promise.allSettled([
			getBonuses(),
			getClaimedRewards(),
		]);

		if (
			rewardsResult.status !== 'fulfilled' ||
			claimedResult.status !== 'fulfilled'
		) {
			return [];
		}

		const allBonuses = rewardsResult.value.bonuses || [];

		const claimedBonusIds = new Set(
			(claimedResult?.value?.bonuses || []).map((b: any) => b.bonusId)
		);

		const filteredBonuses = allBonuses.filter(
			(bonus: any) => !claimedBonusIds.has(bonus.id)
		);
		// bonus.status === 'LIVE' &&

		setOfferRewards({
			featuredBonus: rewardsResult?.value?.featuredBonus || [],
			bonuses: filteredBonuses || null,
		});
		setClaimedRewards({
			bonuses: claimedResult?.value?.bonuses || [],
			claimed: claimedResult?.value?.claimed || 0,
		});
		// setOfferRewards(allBonuses);

		return allBonuses?.filter((bonus: any) => !claimedBonusIds.has(bonus.id));
	}, [getBonuses, getClaimedRewards]);

	return {
		// getClaimedRewards,
		getUnclaimedBonuses,
		error: null,
		loading: false,
	};
};

export default useGetRewards;
